<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { useAuthStore } from '@/stores/auth-store'

import RoutesTable from '@/components/cargo-loading/RoutesTable.vue'
import MyPanel from '@/components/my-components/MyPanel.vue'
import CrumbsAndActions from '@/components/layout/CrumbsAndActions.vue'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'

const { t } = useI18n()
const authStore = useAuthStore()
</script>

<template>
    <CrumbsAndActions v-if="authStore.companyId">
        <Breadcrumb :to="{ name: 'cl' }" v-text="t('cargoLoading')" />
        <Breadcrumb current v-text="t('routes')" />
    </CrumbsAndActions>

    <RouterView />

    <MyPanel v-if="authStore.companyId" shadow>
        <RoutesTable />
    </MyPanel>
</template>
